/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Box, lighten, Stack } from '@mui/material';
import Image from 'next/image';
import React, { FC } from 'react';

import config from '@/config';

const PageDefault: FC = () => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{ flexGrow: 1, bgcolor: (theme) => lighten(theme.palette.primary[50], 0.75) }}
    >
      <Box sx={{ filter: 'contrast(0)', opacity: 0.1 }}>
        <Image src={`/images/${config.public.brandName}/logo.svg`} width={350} height={100} />
      </Box>
    </Stack>
  );
};

export default PageDefault;
